import React, { Component } from 'react';
import { connect } from 'react-redux';
import Dropdown from '../../inputs/Dropdown';
import { deleteVehicleColumnOption, updateVehicleColumnOption } from '../../actions/apiDepartmentUpdates';
import { departmentsForPortal } from '../../utils/departmentsForPortal';

class DisplayOptions extends Component {
	constructor(props) {
		super(props);
		this.state = {
			value: this.props.value,
			optionNames: DisplayOptions.namesFromOptions(props.options),
		};
		this.deleteOption = this.deleteOption.bind(this);
		this.onChange = this.onChange.bind(this);
		this.onChangeName = this.onChangeName.bind(this);
		this.onBlurName = this.onBlurName.bind(this);
		this.onKeyDownName = this.onKeyDownName.bind(this);
		this.onChangeAutomove = this.onChangeAutomove.bind(this);
		this.automoveDestinations = this.automoveDestinations.bind(this);
	}

	static namesFromOptions(options) {
		const optionNames = {};
		(options || []).forEach((option) => {
			optionNames[option.id] = option.name;
		});
		return optionNames;
	}

	componentDidUpdate(prevProps) {
		const prev = (prevProps.options || []).map(o => `${o.id}:${o.name}`).join('|');
		const next = (this.props.options || []).map(o => `${o.id}:${o.name}`).join('|');
		if (prev !== next) {
			this.setState({ optionNames: DisplayOptions.namesFromOptions(this.props.options) });
		}
	}

	onChange(e) {
		this.setState({ value: e.value });
	}

	onChangeName(e) {
		const id = e.target.dataset.dbid;
		this.setState({
			optionNames: { ...this.state.optionNames, [id]: e.target.value },
		});
	}

	onBlurName(e) {
		const id = e.target.dataset.dbid;
		const name = (e.target.value || '').trim();
		const original = (this.props.options || []).find(o => String(o.id) === String(id));
		if (!original) {
			return;
		}
		if (!name || name === original.name) {
			if (this.state.optionNames[id] !== original.name) {
				this.setState({
					optionNames: { ...this.state.optionNames, [id]: original.name },
				});
			}
			return;
		}
		this.props.updateVehicleColumnOption(id, this.props.column_id, { id, name }, 'editOptionError');
	}

	onKeyDownName(e) {
		if (e.key === 'Enter') {
			e.preventDefault();
			e.target.blur();
		}
	}

	onChangeAutomove(e) {
		const id = e.target.dataset.dbid;
		const errorType = 'editOptionError';
		const { column_id } = this.props;
		const data = { id, automove: e.target.checked };
		this.props.updateVehicleColumnOption(id, column_id, data, errorType);
	}

	deleteOption(e) {
		const id = e.currentTarget.dataset.dbid;
		const errorType = 'delete option';
		const { column_id } = this.props;
		this.props.deleteVehicleColumnOption(id, column_id, errorType);
	}

	automoveDestinations(value) {
		const remove_department_types = ['recently sold', 'data step', 'all reconditioning'];
		const portalDepartments = departmentsForPortal(
			this.props.departments,
			this.props.current_dealership,
			{ selectedId: value },
		);
		const options = portalDepartments.map((option) => {
			let selected = false;
			if (value === parseInt(option.id, 10)) {
				selected = true;
			}

			var obj = {
				id: option.id, label: option.name, value: option.id, selected,
			};
			if (!remove_department_types.includes(option.department_type)) {
				return obj;
			}
		});
		return options.filter(e => e);
	}

	render() {
		const options = this.props.options || [];
		let cols = [];

		if (typeof options !== 'undefined') {
			cols = options.map(option => <li className="list-group-item" key={`opt_${option.id}`}>
				<div className="d-flex align-items-center justify-content-between">
					<input
						className="form-control me-2"
						type="text"
						data-dbid={option.id}
						value={this.state.optionNames[option.id] ?? option.name}
						onChange={this.onChangeName}
						onBlur={this.onBlurName}
						onKeyDown={this.onKeyDownName}
						aria-label={`Option name ${option.name}`}
					/>
					<button type="button" className="btn btn-sm btn-danger" data-dbid={option.id} onClick={this.deleteOption}>x</button>
				</div>
				<div className="d-flex align-items-center pt-1">
					<span className="switch">
						<input
							onChange={this.onChangeAutomove}
							checked={option.automove === true}
							type="checkbox"
							data-dbid={option.id}
							id={`option_automove_${option.id}`}
						/>
						<label className="text-capitalize" htmlFor={`option_automove_${option.id}`}>AutoMove</label>
					</span>
					{option.automove === true && <div className="ps-2 flex-grow-1">
						<Dropdown
							titleHelper={''}
							title={'Choose AutoMove Destination'}
							value={option.automove_destination}
							name={'automove_destination'}
							option_id={option.id}
							column_id={this.props.column_id}
							update_type={'option'}
							className={'form-control'}
							list={this.automoveDestinations(option.automove_destination)}
						/>
                                                    </div>}
				</div>
                                                    </li>);
		}

		return (
			<div className="p-2">
				<div className="showOptions">
					<ul className="list-group">
						<li className="list-group-item blockquote text-center">Add/Edit/Delete Options</li>
						{cols}
					</ul>
				</div>
			</div>

		);
	}
}

const mappedActions = {
	deleteVehicleColumnOption,
	updateVehicleColumnOption,
};

function mapStateToProps(state) {
	return {
		departments: state.settings_departments.original_departments,
		current_dealership: state.settings_dealerships.current_dealership,
	};
}
export default connect(mapStateToProps, mappedActions)(DisplayOptions);
